module.exports = __webpack_public_path__ + "img/DragArrow.b9f05d42.svg";